import { Box, Button } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { routes } from "schemas/routes";

import Drawer from "components/Drawer";
import ScheduledThreadPreview from "features/Influencer/ContactList/NewOutreachTable/Scheduled/ScheduledThreadPreview";

export default function CampaignScheduledDrawer() {
  const navigate = useNavigate();
  const { campaignId } = useParams();

  const close = () => navigate(`/${routes.campaignView}/${campaignId}`);

  return (
    <Drawer
      width={{ xs: "auto", md: "50%", lg: "40%" }}
      open
      onClose={close}
      sx={{ borderRadius: 0 }}
    >
      <Box sx={{ pt: 1, px: 1 }}>
        <Button color="secondary" size="small" onClick={close}>
          <Box
            component="i"
            className="fa-solid fa-chevron-left"
            sx={{ mr: 1 }}
          />
          Back
        </Button>
      </Box>
      <ScheduledThreadPreview />
    </Drawer>
  );
}
